import React from 'react';

import Modal from '../component';

const ModalSetFS = (props) => <Modal position="wide" {...props} />;

export default ModalSetFS;
